//#region Imports

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';


import * as appStoreActions from './app-store.actions';
import * as evtArgsHelpers from './helpers/event-args-helper';
import { AppBaseAction } from './app-base-action';
import { OutputActionEventArgs } from './event-args/output-event-args';


import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/takeWhile';
import { RestServiceArgs } from './helpers/rest-service-args';
//#endregion


@Injectable()

export class AppActionDispatcher<T> extends Subject<T> {
  constructor(private http: HttpClient) {
    super();
  }

  //#region private-methods

  private generateEffect(apiArgs: RestServiceArgs<T>,
    outputEvtArgs: Array<OutputActionEventArgs>,
    dispatchOutputAction: boolean
  ): Observable<Array<AppBaseAction<T>>> {
  //  debugger;
    return this.http[apiArgs.Type.toString()](apiArgs.Url, apiArgs.data)
      .takeWhile(() => dispatchOutputAction)
      .map((res) => [...evtArgsHelpers.getActionTypesInstances(outputEvtArgs,
        res)])
      .catch(error => new appStoreActions.DefaultError(error));

  }

  //#endregion


  public dispatch<V>(action: AppBaseAction<T>, store: Store<V>) {
  //  debugger;
    if (action.ActionBaseEventArgs.ApiArgs) {
      {
        const generatedEffect = this.generateEffect(action.ActionBaseEventArgs.ApiArgs,
          action.ActionBaseEventArgs.OutputActions, action.ActionBaseEventArgs.DispatchOutputAction);
        generatedEffect.subscribe((actions: Array<AppBaseAction<T>> | AppBaseAction<T>) => {
          if (Array.isArray(actions)) {
            (actions as Array<AppBaseAction<T>>).forEach(actn => {
              store.dispatch(actn);
            });
          } else {
            store.dispatch(actions as AppBaseAction<T>);
          }
        });
      }
    }
  }
}
